export default "__VITE_ASSET__VkPPhn6n__"